export default "__VITE_ASSET__CgwYSzMl__"